import SFAuthService, { NO_USER } from 'app/services/sfAuth/SFAuthService'
import { backendParsers } from '../Common'
import { CommonFlowResult } from '../salesforce-maps/CommonTypes'
import { ErrorLog } from '../salesforce-maps/ErrorLog'

export const updateErrorLogByFlow = async (
  toUpdate: Partial<ErrorLog> & { id: string } | Array<Partial<ErrorLog> & { id: string }>
): Promise<CommonFlowResult[]> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return conn.requestPost('/actions/custom/flow/App_Update_Error_Log', {
    inputs: [
      {
        toUpdate: Array.isArray(toUpdate)
          ? toUpdate.map(obj => (backendParsers['Error Log'].Salesforce.out(obj)))
          : [
              backendParsers['Error Log'].Salesforce.out(toUpdate)
            ]
      }
    ]
  })
}
